// Optimized homepage bundle - only includes components needed for homepage and navigation
// This significantly reduces bundle size compared to application.js

import ReactOnRails from "react-on-rails";
import "@rails/actioncable";
import { wrapWithErrorBoundary } from "@/shared/components/error";
import React from "react";

// ========================================
// HOMEPAGE-SPECIFIC COMPONENTS ONLY - Now using organized components
// ========================================

// Homepage Components (used on page/home.html.erb)
import { JobSpotlight } from "@/domains/jobs";
import { BlogPosts, Testimonials } from "@/domains/content";

// Job Search Component (used in layouts/_banner.html.erb if banner is shown)
import { JobHome } from "@/domains/jobs";
import { globalComponents } from '@/shared/registerGlobalComponents';

// AI Assistant (used in layouts/application.html.erb for practice users)

// Lazy load messaging components (only needed for signed-in users with chat enabled)
const SBChatLazy = React.lazy(() =>
    import("@/domains/messaging").then(module => ({ default: module.SBChat }))
);
const SBMobileBannerLazy = React.lazy(() =>
    import("@/domains/messaging").then(module => ({ default: module.SBMobileBanner }))
);

// Wrapper components with Suspense for lazy loading
const SBChat = (props) => (
    <React.Suspense fallback={<div>Loading...</div>}>
        <SBChatLazy {...props} />
    </React.Suspense>
);

const SBMobileBanner = (props) => (
    <React.Suspense fallback={<div></div>}>
        <SBMobileBannerLazy {...props} />
    </React.Suspense>
);

// Register only the components needed for homepage + navigation
ReactOnRails.register(wrapWithErrorBoundary({
  ...globalComponents,
    // Homepage components
    JobSpotlight,
    BlogPosts,
    Testimonials,

    // Navigation components (lazy loaded)
    SBChat,
    SBMobileBanner,

    // Job search for banner (conditional)
    JobHome,

    // AI Assistant
}));

// Homepage-specific optimizations and performance tracking
const initializeHomepageOptimizations = () => {
    // Homepage-specific analytics
    if (typeof gtag !== 'undefined') {
        gtag('event', 'page_view', {
            page_title: 'Homepage - Optimized Bundle',
            page_location: window.location.href,
            bundle_type: 'homepage_optimized',
            components_loaded: Object.keys(ReactOnRails.registeredComponents()).length
        });
    }

    // Optimize homepage images with lazy loading
    const images = document.querySelectorAll('img[data-lazy]');
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.lazy;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });
        images.forEach(img => imageObserver.observe(img));
    }

    // Performance measurement
    if (window.performance && window.performance.mark) {
        window.performance.mark('homepage-bundle-initialized');
    }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeHomepageOptimizations);

// Log optimized bundle info for debugging
console.log('🏠 OPTIMIZED HOMEPAGE BUNDLE LOADED!');
console.log('Components registered:', Object.keys(ReactOnRails.registeredComponents()).length);
console.log('Optimized components:', Object.keys(ReactOnRails.registeredComponents()));
console.log('Bundle reduction: 68+ components → ' + Object.keys(ReactOnRails.registeredComponents()).length + ' components');

// Add bundle info for performance monitoring
if (typeof window !== 'undefined') {
    window.homepageBundleLoaded = true;
    window.homepageBundleOptimized = true;
    window.homepageComponentCount = Object.keys(ReactOnRails.registeredComponents()).length;
}
